/**
 * Footer for the CoverageDetails page. Wraps the shared `Footer` primitive.
 */
import { Footer } from "@risalabs_frontend_org/oasis-ui-kit";
import React from "react";

interface CoverageDetailsFooterProps {
  submitButtonText: string;
  /** When true, disables the footer submit (Continue) button on the active path. */
  isContinueDisabled?: boolean;
  /**
   * Tooltip shown on the disabled Continue button. When omitted, a generic
   * "complete all required fields" message is used as a fallback.
   */
  tooltipContent?: React.ReactNode;
  onCancelClick: () => void;
  onSubmitClick: () => void;
}

export const CoverageDetailsFooter: React.FC<CoverageDetailsFooterProps> = ({
  submitButtonText,
  isContinueDisabled = false,
  tooltipContent,
  onCancelClick,
  onSubmitClick,
}) => {
  return (
    <div className="coverage-details--footer">
      <Footer
        cancelButtonText={"Go Back"}
        submitButtonText={submitButtonText}
        onCancelClick={onCancelClick}
        onSubmitClick={onSubmitClick}
        isDisabled={isContinueDisabled}
        useNative={false}
        showTooltip={isContinueDisabled}
        tooltipContent={
          isContinueDisabled
            ? (tooltipContent ??
              "Please complete all required fields before continuing.")
            : ""
        }
      />
    </div>
  );
};
